var _rect, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 5.25,
    fill: "url(#paint0_linear_2454_141369)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.12 7.8283C13.1667 7.52624 12.8795 7.28783 12.611 7.40575L7.26181 9.75432C7.06921 9.83888 7.0833 10.1306 7.28305 10.1942L8.38618 10.5455C8.59672 10.6125 8.8247 10.5779 9.00855 10.4509L11.4956 8.7326C11.5706 8.68079 11.6524 8.78742 11.5883 8.85349L9.79804 10.6992C9.62438 10.8783 9.65885 11.1817 9.86774 11.3127L11.8721 12.5696C12.0969 12.7106 12.3861 12.569 12.4282 12.2973L13.12 7.8283Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2454_141369",
    x1: 10.5,
    y1: 4.75,
    x2: 10.5,
    y2: 15.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.0a76de3349f58bfa6ddefe375fe55714.svg";
export { ForwardRef as ReactComponent };